// Entry files are intended for importing and executing functions and classes only. They should not contain any logic.
import search from '../objects/search'

search()
